export default "__VITE_ASSET__DIuFvORk__"